<template>
  <div>
    <div class="container">
      <Transition>
        <div v-if="showMessage">
          <section>
            <div class="mt-3 mb-3">
              <b-message
                :title="messageTitle"
                type="is-warning"
                has-icon
                aria-close-label="Close"
                size="is-medium"
                v-on:close="toggleMessage"
              >
                {{ messageContent }}
              </b-message>
            </div>
          </section>
        </div>
      </Transition>

      <Transition>
        <div v-if="loading">
          <section class="section is-large">
            <progress class="progress is-large is-primary" max="100" />
          </section>
        </div>
      </Transition>

      <Transition>
        <div v-if="showEmptyList">
          <section class="section is-large">
            <h1 class="title">Niciun test disponibil.</h1>
          </section>
        </div>
      </Transition>

      <Transition>
      
    </Transition>

      <Transition>
        <div v-if="showList">
          <section class="section">
            <div v-for="(quizRow, rowIndex) in quizList" :key="rowIndex">
              <div class="columns is-centered">
                <div
                  v-for="(quizColumn, columnIndex) in quizRow.columns"
                  :key="columnIndex"
                >
                  <div class="column">
                    <div class="card">
                      <div class="card-content">
                        <p class="title">Categorie: {{ quizColumn.name }}</p>
                        <p class="subtitle">Token: {{ quizColumn.token }}</p>
                      </div>
                      <footer class="card-footer">
                        <a
                          v-on:click="startTest(quizColumn.token)"
                          class="card-footer-item"
                          >Start</a
                        >
                      </footer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import RestResource from "../services/one-api.js";
export default {
  methods: {
    sendMessage(message) {
      this.toggleMessage();
      this.messageContent = message;
      this.showMessage = true;
    },

    toggleMessage() {
      this.showMessage = false;
      this.messageContent = "";
    },

    startTest(token) {
      this.$router.push({ name: "quiz", params: { id: token } });
    },

    async runWf(wfName, wfMethod, args) {
      let restData = null;
      try {
        restData = await this.restService.workflow(wfName, wfMethod, args);
      } catch (err) {
        this.sendMessage(err);
        return null;
      }
      return restData;
    },

    async getQuizList() {
      let restData = await this.runWf("DroneExamAux", "getQuizList", {});

      if (restData === null) {
        return;
      }

      this.quizList = restData.data;
    },
  },
  async mounted() {
    this.restService = RestResource(this.axios);

    await this.getQuizList();

    this.loading = false;

    if (
      this.quizList !== null &&
      this.quizList.length > 0 &&
      this.quizList[0].columns !== null &&
      this.quizList.length > 0
    ) {
      this.showList = true;
    } else {
      this.showEmptyList = true;
    }
  },
  data() {
    return {
      restService: null,
      quizList: [],
      showList: false,
      showEmptyList: false,

      loading: true,

      messageTitle: "Mesaj eroare",
      messageContent: "",
      showMessage: false,
    };
  },
};
</script>
